core.filter('ageString', [function () {
    return function (input) {
        function getAgeString(age) {
            var ageString = age + '';
            if(age === 1) {
                ageString = 'Rok';
            }

            if(age > 10 && age < 20) {
                ageString += ' lat';
            } else if(age % 10 == 2 || age % 10 == 3 || age % 10 == 4) {
                ageString += ' lata';
            } else {
                ageString += ' lat';
            }
            return ageString;
        }

        return getAgeString(input);
    };
}]);
